module.exports = __webpack_public_path__ + "img/app-store.ebd9d38.svg";